import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useStoryblok, StoryblokComponent } from "@storyblok/react";

const pathToSlug = (pathname) => {
  if (!pathname || pathname === "/") return "home";

  return pathname.replace(/^\/+/, "").replace(/\/+$/, "");
};

const isInStoryblokEditor = () => {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(window.location.search);

  return params.has("_storyblok");
};

function App() {
  const location = useLocation();
  const slug = pathToSlug(location.pathname);

  const inStoryblokEditor = isInStoryblokEditor();
  const configuredVersion =
    process.env.REACT_APP_STORYBLOK_VERSION;

  // Editor mode must take precedence over the Netlify setting
  const version = inStoryblokEditor
    ? "draft"
    : configuredVersion === "draft"
    ? "draft"
    : "published";

  const story = useStoryblok(slug, { version });

  const [displayStory, setDisplayStory] = useState(null);
  const [isNavigating, setIsNavigating] = useState(false);
  const prevSlugRef = useRef(slug);

  useEffect(() => {
    if (prevSlugRef.current !== slug) {
      setIsNavigating(true);
      prevSlugRef.current = slug;
    }
  }, [slug]);

  useEffect(() => {
    if (story?.content) {
      setDisplayStory(story);
      setIsNavigating(false);
    }
  }, [story]);

  if (!displayStory?.content) {
    // Preview access and still no loading flash
    // Failure should show up with text for debugging
    if (inStoryblokEditor) {
      return (
        <div
          style={{
            padding: "32px",
            fontFamily: "Arial, sans-serif",
            color: "#00033E",
          }}
        >
          Unable to load the Storyblok preview. Check the deployed
          Storyblok Preview token and the failed cdn/stories request.
        </div>
      );
    }

    return null;
  }

  return (
    <>
      <StoryblokComponent blok={displayStory.content} />

      {isNavigating && (
        <div className="fixed inset-0 pointer-events-none bg-black/10 backdrop-blur-[1px] transition-opacity" />
      )}
    </>
  );
}

export default App;